/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIShortcode } from '@/models/api/shortcode.model'

const resource = {
    main: 'services',
    module: 'shortcodes'
}

export class ShortcodesServices {
    public static getShortcodes () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getShortcodesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getShortcodesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createShortcodes (params: APIShortcode) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editShortcodes (params: APIShortcode) {
        return service.put(`${resource.main}/${resource.module}/${params.shortcodeId}`, params)
    }

    public static deleteShortcodes (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreShortcodes (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
